import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface RetailerFileValidationRejectedProps extends BaseTemplateProps {
  filename: string
  rejectedRowCount: number
  validationQueries: string
}

export const RetailerFileValidationRejectedRows: TemplateDefinition<RetailerFileValidationRejectedProps> =
  {
    renderParams: (props: RetailerFileValidationRejectedProps) => ({
      messageKey: 'notificationsDomain.templates.retailerFileValidationRejectedRows',
      values: {
        filename: props.filename,
        rejectedRowCount: props.rejectedRowCount,
        validationQueries: props.validationQueries,
      },
    }),
  }
